import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import { sizes } from '@hover/blueprint/foundation';
import React from 'react';

interface IconProps extends BoxProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconWidth?: string | number | undefined;
  iconHeight?: string | number | undefined;
}

const CustomIcon = ({
  icon: IconComponent,
  color,
  iconWidth,
  iconHeight,
  ...props
}: IconProps) => (
  <Box
    alignItems="center"
    justifyContent="center"
    {...props}
    color={color}
    fill={color}
    padding="100"
    stroke={color}
    sx={{ '& svg path': { stroke: color } }}
  >
    <IconComponent
      height={iconHeight || sizes[200]}
      width={iconWidth || sizes[200]}
    />
  </Box>
);

export { CustomIcon };
